import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';

// Variables Globales
import { Globals } from './global/global';

// Guards
import { AuthGuard } from './guards/auth.guard';

// Services
import { AuthService } from './auth/auth.service';
import { MenuService } from './menu/menu.service';
import { PerfilService } from './perfil/perfil.service';
import { CommonService } from './common/common.service';
import { UsuarioService } from './usuario/usuario.service';
import { AccesoService } from './acceso/acceso.service';
import { AbonadoService } from './abonado/abonado.service';
import { ClienteService } from './cliente/cliente.service';
import { PlanService } from './plan/plan.service';
import { AbonadoseguridadService } from './abonado/abonadoseguridad.service';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    HttpClientModule
  ],
  providers: [
    Globals,
    AuthGuard,
    AuthService,
    MenuService,
    PerfilService,
    CommonService,
    UsuarioService,
    AccesoService,
    AbonadoService,
    ClienteService,
    PlanService,
    AbonadoseguridadService
  ]
})
export class ServiceModule { }
